import User from "../models/User";
import Item from "./furniture/item";
import { PRICE_MODES } from "../constants/priceModes";
import LayoutSize from "./furniture/LayoutSize";
import LayoutBody from "./furniture/LayoutBody";
import Shape from "./furniture/Shape";
import Material from "./furniture/Material";

export default class Design {
  id: number = 0;
  user: number | User = 0;
  item: number | Item = 0;
  composition: string | null = null;
  layout_size: LayoutSize | null = null;
  layout_body: LayoutBody | null = null;
  shapes: Record<string, Shape> | null = {}; // elementOrder -> Shape
  materials: Record<string, Material> | null = {}; // "elementOrder_materialOrder" -> Material
  price: number | null = null;
  price_mode: string = PRICE_MODES.ON;
  image: string | null = null;
  image_url: string | null = null;
  consultant: User | null = null;
  request_expired: boolean = false;
  request_price: number | null = null;

  constructor(data: Partial<Design>) {
    Object.assign(this, data);
  }
}
